import React from "react";
import { useState } from "react";
import DetailsModal from "./DetailsModal";
import { FaRegEye } from "react-icons/fa";

const RequestTabel = ({ list }) => {
  const [selected, setSelected] = useState({});
  return (
    <div>
      <div
        className="table-responsive p-0"
        style={{ border: "1px solid #fff", borderRadius: "20px" }}
      >
        <table
          className="table table-bordered text-center mb-0"
          style={{ borderRadius: "20px" }}
        >
          <thead>
            <tr style={{ color: "#000" }}>
              <th scope="col">ردیف</th>
              <th scope="col">شماره صورت</th>
              <th scope="col">شماره تماس</th>
              <th scope="col">مالک</th>
              <th scope="col">نوع ملک</th>
              <th scope="col">آدرس</th>
              <th scope="col">تاریخ و ساعت</th>
              <th scope="col">مشاهده جزییات</th>
            </tr>
          </thead>
          <tbody>
            {list.map((i, index) => (
              <tr style={{ color: "#000" }} key={index}>
                <td>{index + 1}</td>
                <td>{i.requestToken}</td>
                <td>{i.Ex_Owner.tel}</td>
                <td>{i.Ex_Owner.name}</td>
                <td>{i.Ex_Category.name}</td>
                <td>{i.address}</td>
                <td>{i.expert[0]?.Ex_Expertors.faDateTime}</td>
                <td
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdrop"
                  onClick={() => {
                    setSelected(i);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {" "}
                  <FaRegEye />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <DetailsModal item={selected} setSelected={setSelected} />
    </div>
  );
};

export default RequestTabel;
